import React from 'react';
import {
  Link,
  Typography,
  TableContainer,
  Table,
  TableCell,
  TableRow,
  TableBody,
  TableHead,
  Checkbox,
} from '@mui/material';

// MESSAGES
import SentFormattedMessages from '../../../messages/websms/SentFormattedMessages';

// UTILS
import { getZoneOffsettedDate } from '../../../utils/dates';

const SentTable = ({
  sent,
  isSearching,
  setMessageSelected,
  setMessage,
  handleCheckboxChange,
}) => {
  const renderSentTableRows = () => {
    if (isSearching) {
      return (
        <TableRow>
          <TableCell colSpan={7} sx={{ paddingY: 2 }}>
            <Typography>{SentFormattedMessages.searchingText}</Typography>
          </TableCell>
        </TableRow>
      );
    } else if (!sent || (sent && sent.length === 0)) {
      return (
        <TableRow>
          <TableCell colSpan={7} sx={{ paddingY: 2 }}>
            <Typography>{SentFormattedMessages.noResult}</Typography>
          </TableCell>
        </TableRow>
      );
    } else {
      return sent.map((message, index) => {
        let rezoned = getZoneOffsettedDate(message.sms_sent);

        let smsText;
        try {
          smsText = decodeURIComponent(message.sms_text);
        } catch (err) {
          smsText = 'ERROR: MALFORMED TEXT';
        }

        return (
          <TableRow key={index}>
            <TableCell>{rezoned}</TableCell>
            <TableCell>{message.originator || 'N/A'}</TableCell>
            <TableCell>{message.dest_tn || ''}</TableCell>
            <TableCell>{message.dest_name || ''}</TableCell>
            <TableCell>
              <Link
                onClick={() => {
                  setMessageSelected(true);
                  setMessage(message);
                }}
                tabIndex={0}
              >
                {smsText}
              </Link>
            </TableCell>
            <TableCell>{message.sent_flag || ''}</TableCell>
            <TableCell>
              <Checkbox
                value={message.sms_id}
                onChange={(event) =>
                  handleCheckboxChange(event, message.sms_id)
                }
                disabled={message.sent_flag !== 'Pending'}
                size="small"
              />
            </TableCell>
          </TableRow>
        );
      });
    }
  };

  return (
    <TableContainer
      sx={{
        marginBottom: 4,
        overflowX: 'auto',
        width: '100%',
      }}
    >
      <Table
        variant="rounded"
        sx={{
          minWidth: 1000,
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell width="15%">
              {SentFormattedMessages.dateTimeText}
            </TableCell>
            <TableCell width="15%">{SentFormattedMessages.fromText}</TableCell>
            <TableCell width="15%">{SentFormattedMessages.toHeader}</TableCell>
            <TableCell width="15%">{SentFormattedMessages.name}</TableCell>
            <TableCell width="20%">
              {SentFormattedMessages.messageText}
            </TableCell>
            <TableCell width="15%">
              {SentFormattedMessages.statusHeader}
            </TableCell>
            <TableCell width="5%" sx={{ color: 'grey.700' }}>
              Select
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderSentTableRows()}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default SentTable;
